import PropTypes from 'prop-types';
import React from 'react';
import { css } from 'emotion';
import { DropdownMenu } from 'react-dd-menu';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { connect } from 'react-redux';
import { MenuAction, MenuItem } from 'components/menu/MenuItems';
import DropdownCaret from 'components/menu/DropdownCaret';
import UserBubble from 'components/style/UserBubble';
// TODO (Nicholas): remove the ajax get util
import { setClientCookie } from 'utils/cookie';
import styles from './ProfileMenu.module.css';
import 'react-dd-menu/dist/react-dd-menu.min.css';
import { roles as userRoles } from 'config/constants';
import { isUndefined } from 'lodash';
import { PRIMARY_BLUE, WHITE } from 'config/colors';
import { logoutAuth0andRedirect } from 'utils/authentication';
import { withRouter } from 'react-router-dom';
import { API_URL, ADMIN_SETTINGS_URL_SEGMENT } from 'config/constants';

// NOTE: This width sets width for entire menu
const width = '230px';

const popoverStyle = {
    backgroundColor: WHITE,
    color: 'black',
    borderColor: PRIMARY_BLUE,
    boxShadow: 'none',
    maxWidth: '300px',
};

class ProfileMenu extends React.Component {
    static propTypes = {
        isAdmin: PropTypes.bool,
        isWaypointAssociate: PropTypes.bool,
        isWaypointSysadmin: PropTypes.bool,
        userId: PropTypes.number,
        clientId: PropTypes.number,
        clients: PropTypes.array,
    };

    state = { isMenuOpen: false };

    toggleMenu = () => {
        this.setState({ isMenuOpen: !this.state.isMenuOpen });
    };

    closeMenu = () => {
        this.setState({ isMenuOpen: false });
    };

    // TODO: Utlize url segments in config/constants in these goto methods
    gotoProfile = () => {
        this.props.history.push('/settings/user/personal');
    };

    gotoUserManagement = () => {
        this.props.history.push(`${ADMIN_SETTINGS_URL_SEGMENT}/users`);
    };

    logout = (e) => {
        e.preventDefault();

        fetch(`${API_URL}/logout`, {
            method: 'GET',
            credentials: 'include',
        }).then((_) => logoutAuth0andRedirect());
    };

    renderAvatarButton = () => {
        // TODO (Nicholas): Use recompose to share this menu background behavior
        const { isMenuOpen } = this.state;
        return (
            <div
                className={styles.userAvatarContainer}
                style={{
                    backgroundColor: isMenuOpen
                        ? '#00A7E4'
                        : 'rgba(0, 0, 0, 0)',
                }}
                onClick={this.toggleMenu}
            >
                <UserBubble
                    className={styles.userBubbleAdjustments}
                    userId={this.props.userId}
                />
                {/* NOTE: Leaving this style here because it's purely positional */}
                <DropdownCaret style={{ transform: 'translateY(4px)' }} />
            </div>
        );
    };

    renderTitleBar = (name) => {
        return (
            <div className={styles.sectionTitle}>
                {name}
                <i
                    className="fa-solid fa-chevron-down"
                    size="lg"
                    className={styles.sectionChevron}
                />
            </div>
        );
    };

    renderAdminMenu = () => {
        const { hasUserManagement, isWaypointAssociate, isWaypointSysadmin } =
            this.props;
        const linkDisabled = css`
            color: #d9d9d9 !important;
            &:hover {
                cursor: not-allowed !important;
            }
        `;
        // NOTE (Daniel): Add new menu items here
        // TODO (Daniel): Abstract these access level checks to a HOC or route middleware
        // NOTE (Daniel): The display key on each menuItem can be use to progammatically hide or show depending on feaure flags

        const menuItems = [
            {
                name: 'Admin Panel',
                handler: hasUserManagement ? this.gotoUserManagement : null,
                display: hasUserManagement,
            },
        ];

        return (
            <div>
                {this.renderTitleBar('ADMINISTRATION')}
                {menuItems.map(({ name, handler, display }, idx) => {
                    if (isUndefined(name)) {
                        return null;
                    }
                    if (!isUndefined(display) && !display) {
                        return null;
                    }
                    if (name === 'Admin Panel' && !hasUserManagement) {
                        return (
                            <OverlayTrigger
                                key={idx}
                                placement={'left'}
                                trigger={['hover', 'focus']}
                                overlay={
                                    <Popover
                                        style={popoverStyle}
                                        id="popover-user-management"
                                    >
                                        To view Admin Panel, please contact
                                        support@waypointbuilding.com
                                    </Popover>
                                }
                            >
                                {/* TODO : Clean up div when fragments are available */}
                                <div>
                                    <MenuAction
                                        style={{ width: 'inherit' }}
                                        className={linkDisabled}
                                    >
                                        {name}
                                    </MenuAction>
                                </div>
                            </OverlayTrigger>
                        );
                    }
                    return (
                        <MenuAction
                            key={idx}
                            style={{ width: 'inherit' }}
                            onClick={handler}
                        >
                            {name}
                        </MenuAction>
                    );
                })}
            </div>
        );
    };

    render() {
        const { isAdmin, clients, clientId } = this.props;
        return (
            <div data-test="profile-menu">
                <DropdownMenu
                    toggle={this.renderAvatarButton()}
                    align="right"
                    menuAlign="right"
                    animate={false}
                    isOpen={this.state.isMenuOpen}
                    close={this.closeMenu}
                >
                    {this.renderTitleBar('PORTFOLIO')}
                    <div className={styles.portfolioSectionContainer}>
                        {clients &&
                            clients.length &&
                            clients.map((client) => {
                                return (
                                    <MenuItem
                                        to={'/'}
                                        key={client.id}
                                        style={{ width }}
                                        active={clientId === client.id}
                                        onClick={() => {
                                            // Clear sessionStorage to avoid stale client objects
                                            window.sessionStorage.clear();
                                            setClientCookie(client.id);
                                        }}
                                    >
                                        <span
                                            className={[
                                                styles.portfolioClientName,
                                                styles.ddMenuOverrides,
                                                'dd-item-ignore',
                                            ].join(' ')}
                                        >
                                            {client.name}
                                        </span>
                                    </MenuItem>
                                );
                            })}
                    </div>
                    {/* TODO (Nicholas): Clean up double isAdmin check when react 16 fragments are available */}

                    {isAdmin && this.renderAdminMenu()}

                    {this.renderTitleBar('USER PROFILE')}
                    <MenuAction
                        style={{ width: 'inherit' }}
                        onClick={this.gotoProfile}
                    >
                        My Profile
                    </MenuAction>
                    <MenuAction
                        style={{ width: 'inherit' }}
                        onClick={this.logout}
                    >
                        Log out
                    </MenuAction>
                </DropdownMenu>
            </div>
        );
    }
}

const mapState = (state) => {
    const { id, client_id, userObj, roles } = state.user;
    const clients = userObj.clients;
    const isAdmin = roles.includes(userRoles.CLIENT_ADMIN);
    const isWaypointAssociate = roles.includes(userRoles.WAYPOINT_ASSOCIATE);
    const isWaypointSysadmin = roles.includes(userRoles.WAYPOINT_SYSADMIN);
    const hasUserManagement =
        isWaypointAssociate || isWaypointSysadmin || isAdmin;

    return {
        hasUserManagement,
        isAdmin,
        isWaypointAssociate,
        isWaypointSysadmin,
        clients,
        userId: id,
        clientId: client_id,
        roles,
    };
};

export default withRouter(connect(mapState)(ProfileMenu));
